/** App Routes */
import Dashboard from "../pages/Dashboard";

// import PrototypeTemplate from "../pages/PrototypeTemplate";

/** type a graduate data */
import TypeADuolCoop from "../pages/TypeADuolCoop";

import TypeAStudent from "../pages/TypeAStudent";
import TypeAStudentImportFile from "../pages/TypeAStudentImportFile";

import TypeAImport100New from "../pages/TypeAImport100New";
import TypeAImport100Grad from "../pages/TypeAImport100Grad";
import TypeAImportStatNew from "../pages/TypeAImportStatNew";
import TypeAImportStatGrad from "../pages/TypeAImportStatGrad";

// import TypeADataBenefitsReceived from "../pages/TypeADataBenefitsReceived";

/** type b course data */
// import EB01DataCourseList from "../pages/EB01DataCourseList";
import TypeBImportCourse from "../pages/TypeBImportCourse";
import EB01DataCourse from "../pages/EB01DataCourse";
// import EB01DataExpensesEB01 from "../pages/EB01DataExpensesEB01";
// import EB01DataLearningResult from "../pages/EB01DataLearningResult";
// import EB01DataCourseBenefit from "../pages/EB01DataCourseBenefit";
// import EB01DataTrainingDetails from "../pages/EB01DataTrainingDetails";
import EB01Print from "../pages/print/EB01Print";

import EB02DataCourse from "../pages/EB02DataCourse";
// import EB02DataTrainingDetails from "../pages/EB02DataTrainingDetails";
// import EB02DataTrainingDetailsEnterprise from "../pages/EB02DataTrainingDetailsEnterprise";
// import EB02DataExpensesEB02 from "../pages/EB02DataExpensesEB02";
import EB02Print from "../pages/print/EB02Print";

import EB03DataCourse from "../pages/EB03DataCourse";
// import EB03DataTrainingDetails from "../pages/EB03DataTrainingDetails";
// import EB03DataTrainingDetailsEnterprise from "../pages/EB03DataTrainingDetailsEnterprise";
import EB03Print from "../pages/print/EB03Print";

// import EB04DataCertification from "../pages/EB04DataCertification";
// import EB04DataCertificationTrainingList from "../pages/EB04DataCertificationTrainingList";

import EB04DataCourse from "../pages/EB04DataCourse";
import EB04Print from "../pages/print/EB04Print";

// import EB03DataLecturer from "../pages/EB03DataLecturer";

// import EB05DataSatisfactionAssessment from "../pages/EB05DataSatisfactionAssessment";
import EB05Print from "../pages/print/EB05Print";

/**  demand & supply */
import MatchingDemandSupply from "../pages/MatchingDemandSupply";

import DemandDataManpowerEstablishments from "../pages/DemandDataManpowerEstablishments";
// import DemandDataManpowerEstablishmentsSkillsSet from "../pages/DemandDataManpowerEstablishmentsSkillsSet";

import SupplyDataSupplyHr from "../pages/SupplyDataSupplyHr";
// import SupplyDataSupplyHrInOut from "../pages/SupplyDataSupplyHrInOut";
// import SupplyDataSupplyHrSkillsSet from "../pages/SupplyDataSupplyHrSkillsSet";
// import SupplyDataSupplyHrIndustries from "../pages/SupplyDataSupplyHrIndustries";


/** public data */
import PublicDataPublicizeNews from "../pages/PublicDataPublicizeNews";
// import PublicDataPublicizeNewsList from "../pages/PublicDataPublicizeNewsList";
import PublicDataPublicizeAcademyAndCourse from "../pages/PublicDataPublicizeAcademyAndCourse";
// import PublicDataPublicizeAcademyAndCourseList from "../pages/PublicDataPublicizeAcademyAndCourseList";
import PublicDataPublicizeVacancies from "../pages/PublicDataPublicizeVacancies";
// import PublicDataPublicizeVacanciesList from "../pages/PublicDataPublicizeVacanciesList";

/** eec nets */
import EECNetsData from "../pages/EECNetsData";
// import EECNetsDataMission from "../pages/EECNetsDataMission";
// import EECNetsDataNetworkOperation from "../pages/EECNetsDataNetworkOperation";
// import EECNetsDataNetworkPerformance from "../pages/EECNetsDataNetworkPerformance";
// import EECNetsDataFuturePlans from "../pages/EECNetsDataFuturePlans";
// import EECNetsDataNetworkPartner from "../pages/EECNetsDataNetworkPartner";
// import EECNetsDataIllustration from "../pages/EECNetsDataIllustration";

/** common data */
import CommonDataEnterprise from "../pages/CommonDataEnterprise";
import CommonDataAcademy from "../pages/CommonDataAcademy";

import UserDataExternalUser from "../pages/UserDataExternalUser";
// import UserDataExternalUserSkillsSet from "../pages/UserDataExternalUserSkillsSet";
// import UserDataExternalUserTrainingHistory from "../pages/UserDataExternalUserTrainingHistory";
// import UserDataExternalUserWorkHistory from "../pages/UserDataExternalUserWorkHistory";

import UserDataUser from "../pages/UserDataUser";
import UserDataPermission from "../pages/UserDataPermission";

/** master data */
import MasterDataRegion from "../pages/MasterDataRegion";
import MasterDataProvince from "../pages/MasterDataProvince";
import MasterDataDistrict from "../pages/MasterDataDistrict";
import MasterDataSubDistrict from "../pages/MasterDataSubDistrict";

import MasterDataPrefixName from "../pages/MasterDataPrefixName";
import MasterDataPosition from "../pages/MasterDataPosition";
import MasterDataTargetIndustries from "../pages/MasterDataTargetIndustries";

import CommonDataSkillsSetType from "../pages/CommonDataSkillsSetType";
import CommonDataSkillsSet from "../pages/CommonDataSkillsSet";

import CommonDataSkillsSetCluster from "../pages/CommonDataSkillsSetCluster";

import MasterDataExpenseCategory from "../pages/MasterDataExpenseCategory";
import MasterDataWelfare from "../pages/MasterDataWelfare";
import MasterDataBenefits from "../pages/MasterDataBenefits";
import MasterDataEducationType from "../pages/MasterDataEducationType";
import MasterDataEducationLevel from "../pages/MasterDataEducationLevel";

import MasterDataFaculty from "../pages/MasterDataFaculty";
import MasterDataDepartment from "../pages/MasterDataDepartment";
import MasterDataDepartmentWork from "../pages/MasterDataDepartmentWork";

import MasterDataEducationArea from "../pages/MasterDataEducationArea";

import MasterDataMinistry from "../pages/MasterDataMinistry";
import MasterDataOfficeDepartment from "../pages/MasterDataOfficeDepartment";
import MasterDataOfficeDivision from "../pages/MasterDataOfficeDivision";
import DashboardMockup from "../pages/DashboardMockup";

const prefixApps = '/apps/';

/** App Routes */
export const routes = [    
    { path: prefixApps + 'dashboard', element: <Dashboard /> },
    { path: prefixApps + 'dashboard-mockup', element: <DashboardMockup /> },
    { path: prefixApps + 'network', element: <EECNetsData /> },
        
    /** type a graduate data */
    { path: prefixApps + 'type-a-duol-coop', element: <TypeADuolCoop /> },
    { path: prefixApps + 'type-a-student', element: <TypeAStudent /> },
    { path: prefixApps + 'type-a-student-import-file', element: <TypeAStudentImportFile /> },

    { path: prefixApps + 'type-a-100-new-student-import-file', element: <TypeAImport100New /> },
    { path: prefixApps + 'type-a-100-grad-student-import-file', element: <TypeAImport100Grad /> },
    { path: prefixApps + 'type-a-statistic-new-student-import-file', element: <TypeAImportStatNew /> },
    { path: prefixApps + 'type-a-statistic-grad-student-import-file', element: <TypeAImportStatGrad /> },
    // { path: prefixApps + 'type-a-benefits-received', element: <TypeADataBenefitsReceived /> },

    /** type b course data */
    // { path: prefixApps + 'eb01-course-list', element: <EB01DataCourseList /> },
    { path: prefixApps + 'eb-import-course', element: <TypeBImportCourse /> },
    { path: prefixApps + 'eb01-course', element: <EB01DataCourse /> },
    // { path: prefixApps + 'eb01-expenses-eb01', element: <EB01DataExpensesEB01 /> },
    // { path: prefixApps + 'eb01-learning-result', element: <EB01DataLearningResult /> },
    // { path: prefixApps + 'eb01-course-benefit', element: <EB01DataCourseBenefit /> },
    // { path: prefixApps + 'eb01-training-details', element: <EB01DataTrainingDetails /> },
    { path: prefixApps + 'eb01-print/:id/:buttonlabel?', element: <EB01Print /> },

    { path: prefixApps + 'eb02-course', element: <EB02DataCourse /> },
    // { path: prefixApps + 'eb02-training-details', element: <EB02DataTrainingDetails /> },
    // { path: prefixApps + 'eb02-training-details-enterprise', element: <EB02DataTrainingDetailsEnterprise /> },
    // { path: prefixApps + 'eb02-expenses-eb02', element: <EB02DataExpensesEB02 /> },
    { path: prefixApps + 'eb02-print/:id', element: <EB02Print /> },

    { path: prefixApps + 'eb03-course', element: <EB03DataCourse /> },
    // { path: prefixApps + 'eb03-training-details', element: <EB03DataTrainingDetails /> },
    // { path: prefixApps + 'eb03-training-details-enterprise', element: <EB03DataTrainingDetailsEnterprise /> },
    { path: prefixApps + 'eb03-print/:id', element: <EB03Print /> },
    
    { path: prefixApps + 'eb04-course', element: <EB04DataCourse /> },

    // { path: prefixApps + 'eb04-certification', element: <EB04DataCertification /> },  
    // { path: prefixApps + 'eb04-certification-training-lists', element: <EB04DataCertificationTrainingList /> },  
    { path: prefixApps + 'eb04-print/:id', element: <EB04Print /> },

    // { path: prefixApps + 'eb05-satisfaction-assessment', element: <EB05DataSatisfactionAssessment /> },
    { path: prefixApps + 'eb05-print/:id', element: <EB05Print /> },
    
    /**  demand & supply */
    { path: prefixApps + 'matching-demand-supply', element: <MatchingDemandSupply /> },  

    { path: prefixApps + 'demand-manpower', element: <DemandDataManpowerEstablishments /> },  
    // { path: prefixApps + 'demand-manpower-skills-set', element: <DemandDataManpowerEstablishmentsSkillsSet /> },  

    { path: prefixApps + 'supply-human-resource', element: <SupplyDataSupplyHr /> },  
    // { path: prefixApps + 'supply-human-resource-in-out', element: <SupplyDataSupplyHrInOut /> },  
    // { path: prefixApps + 'supply-human-resource-skills-set', element: <SupplyDataSupplyHrSkillsSet /> },  
    // { path: prefixApps + 'supply-human-resource-industries', element: <SupplyDataSupplyHrIndustries /> },  
    
    /** 
    { path: prefixApps + 'demand-manpower-institution', element: <DemandDataManpowerInstitution /> },   
    { path: prefixApps + 'demand-student-grade-level', element: <DemandDataStudentGradeLevel /> },   
    */

    /** public data */
    { path: prefixApps + 'public-data-publicize-news', element: <PublicDataPublicizeNews /> },
    // { path: prefixApps + 'public-data-publicize-news-list', element: <PublicDataPublicizeNewsList /> },
    { path: prefixApps + 'public-data-publicize-academy-and-course', element: <PublicDataPublicizeAcademyAndCourse /> },
    // { path: prefixApps + 'public-data-publicize-academy-and-course-list', element: <PublicDataPublicizeAcademyAndCourseList /> },
    { path: prefixApps + 'public-data-publicize-vacancies', element: <PublicDataPublicizeVacancies /> },
    // { path: prefixApps + 'public-data-publicize-vacancies-list', element: <PublicDataPublicizeVacanciesList /> },
    
    
    /** eec nets  */
    { path: prefixApps + 'eec-nets-data', element: <EECNetsData /> },
    // { path: prefixApps + 'eec-nets-data-mission', element: <EECNetsDataMission /> },
    // { path: prefixApps + 'eec-nets-data-operation', element: <EECNetsDataNetworkOperation /> },
    // { path: prefixApps + 'eec-nets-data-performance', element: <EECNetsDataNetworkPerformance /> },
    // { path: prefixApps + 'eec-nets-data-future-plans', element: <EECNetsDataFuturePlans /> },
    // { path: prefixApps + 'eec-nets-data-partner', element: <EECNetsDataNetworkPartner /> },
    // { path: prefixApps + 'eec-nets-data-attach', element: <EECNetsDataIllustration /> },


    /** common data and user data */
    { path: prefixApps + 'common-data-enterprise', element: <CommonDataEnterprise /> },
    { path: prefixApps + 'common-data-academy', element: <CommonDataAcademy /> },
    
    { path: prefixApps + 'user-data-external-user', element: <UserDataExternalUser /> },
    // { path: prefixApps + 'user-data-external-user-skills-set', element: <UserDataExternalUserSkillsSet /> },
    // { path: prefixApps + 'user-data-external-user-training-history', element: <UserDataExternalUserTrainingHistory /> },
    // { path: prefixApps + 'user-data-external-user-work-history', element: <UserDataExternalUserWorkHistory /> },

    { path: prefixApps + 'user-data-user', element: <UserDataUser /> },
    { path: prefixApps + 'user-data-permission', element: <UserDataPermission /> },

    /** master data */
    // { path: prefixApps + 'prototype-template', element: <PrototypeTemplate /> },
    
    { path: prefixApps + 'master-data-region', element: <MasterDataRegion /> },
    { path: prefixApps + 'master-data-province', element: <MasterDataProvince /> },
    { path: prefixApps + 'master-data-district', element: <MasterDataDistrict /> },
    { path: prefixApps + 'master-data-subdistrict', element: <MasterDataSubDistrict /> },

    { path: prefixApps + 'master-data-prefix-name', element: <MasterDataPrefixName /> },
    { path: prefixApps + 'master-data-position', element: <MasterDataPosition /> },
    { path: prefixApps + 'master-data-target-industries', element: <MasterDataTargetIndustries /> },
    
    { path: prefixApps + 'common-data-skills-set-type', element: <CommonDataSkillsSetType /> },
    { path: prefixApps + 'common-data-skills-set', element: <CommonDataSkillsSet /> },

    { path: prefixApps + 'common-data-skills-set-cluster', element: <CommonDataSkillsSetCluster /> },

    { path: prefixApps + 'master-data-expense-category', element: <MasterDataExpenseCategory /> },
    { path: prefixApps + 'master-data-welfare', element: <MasterDataWelfare /> },
    { path: prefixApps + 'master-data-benefits', element: <MasterDataBenefits /> },
    { path: prefixApps + 'master-data-education-type', element: <MasterDataEducationType /> },
    { path: prefixApps + 'master-data-education-level', element: <MasterDataEducationLevel /> },
        
    { path: prefixApps + 'master-data-faculty', element: <MasterDataFaculty /> },
    { path: prefixApps + 'master-data-department', element: <MasterDataDepartment /> },
    { path: prefixApps + 'master-data-department-work', element: <MasterDataDepartmentWork /> },

    { path: prefixApps + 'master-data-education-area', element: <MasterDataEducationArea /> },
    
    { path: prefixApps + 'master-data-ministry', element: <MasterDataMinistry /> },
    { path: prefixApps + 'master-data-office-department', element: <MasterDataOfficeDepartment /> },
    { path: prefixApps + 'master-data-office-division', element: <MasterDataOfficeDivision /> },

];
